const { debounce } = window.BAO.Utils
class FooterAccordion extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['trigger', 'panel']
  }

  connectedCallback () {
    super.connectedCallback()

    this.resizeObserver = new ResizeObserver(
      debounce((entries) => {
        const entry = entries.find(
          (entry) => entry?.contentRect?.width !== this.previousWidth,
        )
        if (!entry) return
        this.handleResize(entry)
      }, 250),
    )

    this.setPanelVisibility()
    this.observeWidth()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.resizeObserver.disconnect()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )
  }

  observeWidth () {
    const panelEl = this.els?.panel?.element
    if (!panelEl) return

    this.previousWidth = panelEl.clientWidth
    this.resizeObserver.observe(panelEl)
  }

  handleResize (entry) {
    this.previousWidth = entry.contentRect.width
    this.setPanelVisibility()
  }

  setPanelVisibility () {
    this.els.panel.element.removeAttribute('style')
    this.panelIsHidden = window.BAO.MediaBreakpoints.isXsViewport

    this.els.trigger.element.setAttribute(
      'aria-expanded',
      (!this.panelIsHidden).toString(),
    )
    this.els.panel.element.setAttribute(
      'aria-hidden',
      this.panelIsHidden.toString(),
    )

    this.panelHeight = (() => {
      if (this.panelIsHidden) {
        this.els.panel.element.removeAttribute('aria-hidden')
      }

      const height = this.els.panel.element.offsetHeight
      this.els.panel.element.setAttribute(
        'aria-hidden',
        this.panelIsHidden.toString(),
      )

      return height
    })()
  }

  onTriggerClick () {
    this.toggle(!this.open)
  }

  /**
   * @param {boolean} open
   */
  toggle (open) {
    if (window.BAO.MediaBreakpoints.isMd) return
    if (open === this.open) return

    this.els.trigger.element.setAttribute('aria-expanded', open.toString())

    if (open) {
      this.els.panel.element.setAttribute('aria-hidden', 'false')
      window.BAO.Utils.slideDown(this.els.panel.element, this.panelHeight)
    } else {
      this.els.panel.element.setAttribute('aria-hidden', 'true')
      window.BAO.Utils.slideUp(this.els.panel.element, this.panelHeight)
    }
  }

  get open () {
    return this.els.trigger.element.getAttribute('aria-expanded') === 'true'
  }
}

if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', FooterAccordion)
}
